import React, { Component } from "react";
import ChatForm from "./ChatForm.js";
import ChatbubbleEllipses from "../../resources/icons/ChatbubbleEllipses.jsx";
class MentorChat extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newMessages: 0,
      chatFormOpened: false,
      intervalId: null,
      allowed_mime: null,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    console.log("click");
    this.setState({ chatFormOpened: !this.state.chatFormOpened });
  }
  componentDidMount() {
    this.loadAllowedMime();
    this.loadUpdates();
    this.state.intervalId = setInterval(() => {
      this.loadUpdates();
    }, 5000);
  }
  loadAllowedMime() {
    fetch(this.props.mentorChatApiRoot + "/file/accepted_mime_types.json", {
      method: "GET",
    })
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            allowed_mime: result,
          });
        },
        (error) => {
          console.log(error);
        }
      );
  }
  loadUpdates() {
    fetch(this.props.mentorChatApiRoot + "/message/updates", {
      method: "POST",
      cache: "no-cache",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: localStorage.getItem("mentor_chat_token"),
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            newMessages: result.new_messages,
          });
        },
        (error) => {
          console.log(error);
        }
      );
  }
  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }
  render() {
    const { error, newMessages, chatFormOpened } = this.state;
    if (error) {
      return <div>Ошибка: {error.message}</div>;
    } else {
      return (
        <div>
          <div
            title={localStorage.getItem("mentor_chat_title")}
            className="Widget"
            data-blinker={newMessages > 0 ? "1" : "0"}
            onClick={this.handleClick}
          >
            <ChatbubbleEllipses color="#3b7cbe" height="45px" width="45px" />
            <div className={newMessages > 0 ? "NewMessages" : "NoNewMessages"}>
              {newMessages}
            </div>
          </div>
          <ChatForm
            isOpened={this.state.chatFormOpened}
            closeFunc={this.handleClick}
            allowed_mime={this.state.allowed_mime}
            newMessages={this.state.newMessages}
            mentorChatApiRoot={this.props.mentorChatApiRoot}
          ></ChatForm>
        </div>
      );
    }
  }
}

export default MentorChat;
